export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html' },
];